import { Navigate, Route, Routes as Router } from 'react-router-dom';
import { PrivateRoute, PublicRoute } from 'components';

import {
    Error403,
    Error404,
    Orders,
    Order,
    Shipments,
    Shipment,
    Error401
} from 'views';

import { Login, SignIn } from 'views/Account';
import {
    Warehouses,
    Countries,
    CountryDetails,
    Channels,
    ChannelDetails,
    Inventory,
    WarehouseDetails,
    ReferenceData,
    ReferenceDataDetail,
    Carriers,
    CarrierDetails,
    Users,
    UserDetails,
    ShipmentTypes,
    ShipmentTypeDetails,
    CountryTaxRate
} from 'views/Admin';

let Routes = () => {
    return (
        <Router>
            <Route path="/admin/warehouse" element={<PrivateRoute children={<Warehouses />} />} />
            <Route path="/admin/warehouse/addnew" element={<PrivateRoute children={<WarehouseDetails />} />} />
            <Route path="/admin/warehouse/edit/:id" element={<PrivateRoute children={<WarehouseDetails />} />} />

            <Route path='/admin/referencedata' element={<PrivateRoute children={<ReferenceData />} />} />
            <Route path='/admin/referencedata/addnew' element={<PrivateRoute children={<ReferenceDataDetail />} />} />
            <Route path='/admin/referencedata/edit/:id' element={<PrivateRoute children={<ReferenceDataDetail />} />} />

            <Route path='/admin/shipmenttypes' element={<PrivateRoute children={<ShipmentTypes />} />} />
            <Route path='/admin/shipmenttype/addnew' element={<PrivateRoute children={<ShipmentTypeDetails />} />} />
            <Route path='/admin/shipmenttype/edit/:id' element={<PrivateRoute children={<ShipmentTypeDetails />} />} />

            <Route path="/admin/inventory" element={<PrivateRoute children={<Inventory />} />} />

            <Route path="/admin/channel" element={<PrivateRoute children={<Channels />} />} />
            <Route path="/admin/channel/addnew" element={<PrivateRoute children={<ChannelDetails />} />} />
            <Route path="/admin/channel/edit/:id" element={<PrivateRoute children={<ChannelDetails />} />} />

            <Route path="/admin/country" element={<PrivateRoute children={<Countries />} />} />
            <Route path="/admin/country/addnew" element={<PrivateRoute children={<CountryDetails />} />} />
            <Route path="/admin/country/edit/:id" element={<PrivateRoute children={<CountryDetails />} />} />

            <Route path="/admin/carrier" element={<PrivateRoute children={<Carriers />} />} />
            <Route path="/admin/carrier/addnew" element={<PrivateRoute children={<CarrierDetails />} />} />
            <Route path="/admin/carrier/edit/:id" element={<PrivateRoute children={<CarrierDetails />} />} />

            <Route path="/admin/user" element={<PrivateRoute children={<Users />} />} />
            <Route path="/admin/user/addnew" element={<PrivateRoute children={<UserDetails />} />} />
            <Route path="/admin/user/edit/:id" element={<PrivateRoute children={<UserDetails />} />} />

            <Route path="/admin/countrytaxrate" element={<PrivateRoute children={<CountryTaxRate />} />} />

            <Route path="/orders" element={<PrivateRoute children={<Orders />} />} />
            <Route path="/order/:id" element={<PrivateRoute children={<Order />} />} />

            <Route path="/shipments" element={<PrivateRoute children={<Shipments />} />} />
            <Route path="/shipment/:id" element={<PrivateRoute children={<Shipment />} />} />

            <Route path="/account/login" element={<PublicRoute children={<Login />} />} />
            <Route path="/account/signin" element={<PublicRoute children={<SignIn />} />} />

            <Route path="/error401" element={<PublicRoute children={<Error401 />} />} />
            <Route path="/error403" element={<PublicRoute children={<Error403 />} />} />
            <Route path="/error404" element={<PublicRoute children={<Error404 />} />} />

            {/*va tenuto perchè "login" punta a '/' in Cognito */}
            <Route path="/" element={<Navigate to={"/orders"} />} />

            <Route path="*" element={<Navigate to={"/error404"} />} />
        </Router>
    )
}

export default Routes;